import { ChevronDown, ChevronRight, ChevronUp, Database } from "lucide-react";
import { useEffect, useState } from "react";
import { getAllModels } from "../../Redux/Actions/customTableActions";
import { useDispatch, useSelector } from "react-redux";

const DatabaseSchema = (props) => {
  const { projectId, onFormatChange } = props;
  let dispatch = useDispatch();
  const { customTables, loading, error, emptyCustomTables } = useSelector(
    (state) => state.customTables
  );
  const [databaseFormat, setDatabaseFormat] = useState("json");
  const [collapsedTables, setCollapsedTables] = useState({
    users: false,
    products: false,
    orders: false,
  });
  const [isSchemaCollapsed, setIsSchemaCollapsed] = useState(true);

  const toggleTableCollapse = (tableName) => {
    setCollapsedTables((prev) => ({
      ...prev,
      [tableName]: !prev[tableName],
    }));
  };

  const toggleSchemaCollapse = () => {
    setIsSchemaCollapsed(!isSchemaCollapsed);
  };
  const handleDatabaseFormatChange = (format) => {
    setDatabaseFormat(format);
    if (onFormatChange) {
      onFormatChange(format);
    }
  };
  console.log(customTables);

  useEffect(() => {
    dispatch(getAllModels(projectId));
  }, [projectId]);
  return (
    <div className="mb-6">
      <div
        className="flex items-center justify-between cursor-pointer py-2 border-b border-gray-200 mb-2"
        onClick={toggleSchemaCollapse}
      >
        <h5 className="font-semibold text-gray-800 flex items-center">
          <Database className="h-4 w-4 text-gray-500 mr-2" />
          Database Schema
        </h5>
        <div className="flex items-center text-gray-500">
          <span className="text-xs mr-2">
            {isSchemaCollapsed ? "Show" : "Hide"} schema
          </span>
          {isSchemaCollapsed ? (
            <ChevronDown className="h-4 w-4" />
          ) : (
            <ChevronUp className="h-4 w-4" />
          )}
        </div>
      </div>

      {!isSchemaCollapsed && (
        <div className="border border-gray-300 rounded-md overflow-hidden">
          {/* Schema Header */}
          <div className="bg-gray-50 px-4 py-2 border-b border-gray-300 flex items-center">
            <Database className="h-4 w-4 text-gray-500 mr-2" />
            <span className="font-medium text-gray-700">Export Format</span>
          </div>

          {/* Database Export Format */}
          <div className="bg-gray-50 px-4 py-2 border-b border-gray-300">
            <div className="flex flex-wrap gap-2">
              {/* JSON Format Option */}
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  name="databaseFormat"
                  className="text-red-600 focus:ring-red-500 h-4 w-4 cursor-pointer"
                  checked={databaseFormat === "json"}
                  onChange={() => handleDatabaseFormatChange("json")}
                />
                <span className="text-sm text-gray-700">JSON Format</span>
                <span className="text-xs text-gray-500 ml-1">
                  (Readable, standard)
                </span>
              </label>

              {/* Archive Format Option */}
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  name="databaseFormat"
                  className="text-red-600 focus:ring-red-500 h-4 w-4 cursor-pointer"
                  checked={databaseFormat === "archive"}
                  onChange={() => handleDatabaseFormatChange("archive")}
                />
                <span className="text-sm text-gray-700">Archive (.zip)</span>
                <span className="text-xs text-gray-500 ml-1">
                  (Compressed, faster)
                </span>
              </label>

              {/* Both Formats Option */}
              <label className="flex items-center space-x-2 cursor-pointer">
                <input
                  type="radio"
                  name="databaseFormat"
                  className="text-red-600 focus:ring-red-500 h-4 w-4 cursor-pointer"
                  checked={databaseFormat === "both"}
                  onChange={() => handleDatabaseFormatChange("both")}
                />
                <span className="text-sm text-gray-700">Both Formats</span>
                <span className="text-xs text-gray-500 ml-1">
                  (Maximum compatibility)
                </span>
              </label>
            </div>
          </div>

          {/* Tables */}
          {customTables?.map((table, index) => (
            <div key={index} className="p-4 space-y-4">
              {/* Users Table */}
              <div className="border border-gray-200 rounded-md overflow-hidden">
                <div
                  className="bg-gray-50 px-3 py-2 border-b border-gray-200 flex justify-between items-center cursor-pointer hover:bg-gray-100"
                  onClick={() => toggleTableCollapse("users")}
                >
                  <div className="flex items-center">
                    <ChevronRight
                      className={`h-4 w-4 mr-1 text-gray-500 transition-transform ${
                        !collapsedTables.users ? "rotate-90" : ""
                      }`}
                    />
                    <span className="font-medium text-gray-700">
                      {table.table_name}
                    </span>
                  </div>
                </div>
                {!collapsedTables.users && (
                  <div className="divide-y divide-gray-200">
                    {table.fields.map((field, idx) => (
                      <div
                        key={idx}
                        className="grid grid-cols-12 px-3 py-2 hover:bg-gray-50"
                      >
                        <div className="col-span-4 font-medium text-gray-700">
                          {field.field_name}
                        </div>
                        <div className="col-span-4 font-medium text-gray-700">
                          {field.field_type}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <p className="mt-2 text-xs text-gray-500">
        Database schema will be included in your Docker configuration
      </p>
    </div>
  );
};
export default DatabaseSchema;
